import {Grid} from '@material-ui/core';
import {H5} from 'components/TypographyShortcuts';
import {AddMMCCore} from 'components/mmld/AddMMC';
import {useContext} from 'react';
import {UserContext} from 'context/UserContext';
import ViewMMC from 'components/mmld/ViewMMC';

const MMCLookupPage = () => {
    const {hasMmlds} = useContext(UserContext);

    if (hasMmlds) {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <H5 align='center'>We found your MMC!</H5>
                </Grid>
                <Grid item xs={12}>
                    <ViewMMC />
                </Grid>
            </Grid>
        );
    } else {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <H5 align='center'>Let's Look Up Your MMC</H5>
                </Grid>
                <Grid item xs={12}>
                    <AddMMCCore ButtonProps={{fullWidth: true}} />
                </Grid>
            </Grid>
        );
    }
};

export default MMCLookupPage;
